import { getSDK as getUnlinkSDK } from "../../sdk/UnlinkInstance";
import { LAMPORTS_PER_SOL } from "@solana/web3.js";
import { loadLocalKeys } from "../../db/KeyStorageManager";
import { FEES, MESSAGES_TYPES } from '../../Config';
import { sendInstructionsWithRetry} from '../../utils/SendInstructions';
import dispatchToChat from "../../services/message/DispatchToChat";
import { upsertRatchetKeys } from '../../db/RatchetedConversationKeys';

export async function sendEncryptedMessage({
  conversationId,
  plaintext,
  contactNextViewPublicKey,
  contactIdentityViewPublicKey,
  kyberSecret,
  userId, 
  password, 
  salt,
}) {
  const unlinkSdk = getUnlinkSDK();

  const { 
    viewPublicKey: localViewPublicKey,
    viewPrivateKey: localViewPrivateKey,
  } = await loadLocalKeys({userId, password, salt});

  // generate filter tag
  const filterTag = unlinkSdk.deriveRandomFilterTag({
    viewKey: contactNextViewPublicKey || contactIdentityViewPublicKey,
    bits: 3 ,
  });

  const keypair = await unlinkSdk.generateUnlinkKeypair();
  const localNextViewPublicKey = keypair.viewPublicKey;
  const localNextViewPrivateKey = keypair.viewPrivateKey;

  // create solana transaction instructions
  const { instructions, messageId } = await unlinkSdk.createMessageSendInstructions({
    receiverViewPublicKey: contactNextViewPublicKey || contactIdentityViewPublicKey,
    senderViewPublicKey: localViewPublicKey,
    senderViewPrivateKey: localViewPrivateKey,
    senderNextViewPublicKey: localNextViewPublicKey,
    plaintext: plaintext,
    spamMitigationFeeLamports: FEES.SPAM_MITIGATION_LAMPORTS,
    conversationId,
    kyberSecret,
    filterTag,
  });

  // dispatch own message
  dispatchToChat({
    message: { 
      parsed: {
        version: 1,
        message: plaintext,
      },
      receiverViewPublicKey: contactNextViewPublicKey || contactIdentityViewPublicKey,
      senderViewPublicKey: localViewPublicKey,
      senderNextViewPublicKey: localNextViewPublicKey,
      conversationId,
      messageId,
      messageType: MESSAGES_TYPES.MESSAGE_TYPE_TEXT,
    }, 
    receiverIdentityViewPublicKey: contactIdentityViewPublicKey,
    userId, 
    password, 
    salt,
  });

  // send instructions to solana chain
  await sendInstructionsWithRetry({
    instructions: instructions,
    networkFeeLamports: FEES.NETWORK_FEE_LAMPORTS,
    password,
    userId,
    salt,
  });

  // store new viewkeys for ratcheting
  await upsertRatchetKeys({
    conversationId,
    contactIdentityViewPublicKey,
    localNextViewPublicKey,
    localNextViewPrivateKey,
    userId,
    password,
  });
}